export const STORE_BASIC_AUTH_TOKEN = process.env.STORE_BASIC_AUTH_TOKEN;
